import script from "./CustomerHome.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerHome.vue?vue&type=script&setup=true&lang=js"

import "./CustomerHome.vue?vue&type=style&index=0&id=2f8c37e8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f8c37e8"]])

export default __exports__